module.exports = __webpack_public_path__ + "static/media/Notification.a506145c.svg";